import { staticApi } from "../../services";
import { $config } from "../../conf";
export let dicApi = {
  getDic({ dicId }) {
    return staticApi.request(`/${$config.tenantId}/dic/list/${dicId}.json`);
  },
};
